import React, { createContext, useState } from 'react';
import useScrollPos from 'hooks/useScrollPosition';
import useScreenSize from 'hooks/useScreenSize';

export const layoutContext = createContext();
const { Provider } = layoutContext;

export default function LayoutProvider({ children }) {
  const [height, setHeight] = useState(null);
  const scrollPos = useScrollPos(height);
  const displaySize = useScreenSize();
  return (
    <Provider value={{ ...scrollPos, displaySize, height, setHeight }}>
      {children}
    </Provider>
  );
}
